import {
  Button,
  DialogActions,
  DialogContent,
  MenuItem,
  MenuList,
  Typography
} from '@mui/material'
import { useState } from 'react'

import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { useGetEmployeeRolesQuery } from '../../redux/api'
import { EmployeeRole } from '../../sdk'
import { SwitchUserForm } from './SwitchUserForm'

export const SwitchUserDialog = ({
  handleCloseDialog
}: {
  handleCloseDialog: () => void
}) => {
  const { accessToken, shopId, userId } = useAccessTokenAndShopId()
  const [isUserSelected, setIsUserSelected] = useState<EmployeeRole>()
  const { data: employeeRoles } = useGetEmployeeRolesQuery({
    authorization: accessToken,
    shop: shopId
  })

  return !isUserSelected ? (
    <>
      <DialogContent>
        <Typography variant="subtitle1">
          Switch to a different account by selecting below
        </Typography>
        <MenuList>
          {employeeRoles
            ?.filter((e) => e.userProfile!.id !== userId)
            .map((e) => (
              <MenuItem
                key={e.userProfile!.id!}
                onClick={() => setIsUserSelected(e)}>
                {e.userProfile!.name!}
              </MenuItem>
            ))}
        </MenuList>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDialog}>Cancel</Button>
      </DialogActions>
    </>
  ) : (
    <SwitchUserForm
      employee={isUserSelected}
      setIsUserSelected={setIsUserSelected}
      submitCallback={() => {
        setIsUserSelected(undefined)
        handleCloseDialog()
      }}
    />
  )
}
